// AgriLinkUpdates.jsx

import React from "react";

const updates = [
  {
    dateTime: "2025-04-12T10:00",
    title: "Launch of AgriLink Digital Marketplace",
    desc: "A one-stop digital platform for farmers, FPOs, wholesalers, retailers, and consumers to connect directly."
  },
  {
    dateTime: "2025-04-10T14:30",
    title: "MoU Signed with National Dairy Federation",
    desc: "Collaboration enables dairy farmers and cooperatives to access AgriLink’s tech-driven ecosystem."
  },
  {
    dateTime: "2025-04-08T11:00",
    title: "Farm Advisory Board Finalized",
    desc: "Experts from agri-tech, dairy science, and rural development join to guide AgriLink’s growth."
  },
  {
    dateTime: "2025-04-06T09:45",
    title: "Cold Chain Logistics Pilot",
    desc: "First rollout of AI-enabled cold storage and transport tracking for perishable produce."
  },
  {
    dateTime: "2025-04-04T17:15",
    title: "Soil Health AI Tools Demo",
    desc: "Farmers got a first look at AgriLink’s smart tools for soil testing and crop recommendation."
  },
  {
    dateTime: "2025-04-02T13:30",
    title: "Collaboration with Krishi Vikas Kendras",
    desc: "Partnership brings agricultural extension services directly onto the AgriLink platform."
  },
  {
    dateTime: "2025-03-30T10:00",
    title: "Farmer Producer Organizations Onboarded",
    desc: "10+ FPOs join AgriLink to expand market reach and collective bargaining power for farmers."
  },
  {
    dateTime: "2025-03-28T16:00",
    title: "Beta Testing Begins",
    desc: "Early access to AgriLink’s farm-to-fork commerce and advisory platform now open for select users."
  },
  {
    dateTime: "2025-03-25T12:00",
    title: "First Three Crop Bundles Listed",
    desc: "Seasonal packs of vegetables, fruits, and dairy combos are now available for online ordering."
  },
  {
    dateTime: "2025-03-22T18:30",
    title: "Vision, Mission, Values Published",
    desc: "Our commitment: Empower farmers, enable transparent supply chains, and deliver safe, fresh produce to every home."
  }
];

const AgriLinkUpdates = () => {
  return (
    <section className="py-4 px-6 md:px-4 bg-green-800 min-h-screen">
      <h2 className="text-xl lg:text-2xl font-bold text-center mb-4 text-yellow-200">
        AgriLink Updates
      </h2>
      <div className="space-y-6 mx-auto">
        {updates.map((update, idx) => (
          <div
            key={idx}
            className="bg-gray-800 rounded-lg shadow-md p-5 hover:shadow-lg transition border border-green-200"
          >
            <div className="text-sm text-white mb-1">
              {new Date(update.dateTime).toLocaleString("en-IN", {
                dateStyle: "medium",
                timeStyle: "short"
              })}
            </div>
            <h3 className="text-m lg:text-lg font-semibold text-yellow-200">
              {update.title}
            </h3>
            <p className="text-white text-sm lg:text-m mt-1">{update.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AgriLinkUpdates;
